import { Component, Input } from '@angular/core';
import moment = require('moment');
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { FormUtils } from 'src/app/utils/FormUtils';
import { debit_date_form_keys } from './debit-date-variation.constant';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-debit-date-variation',
  templateUrl: './debit-date-variation.component.html',
  styleUrl: './debit-date-variation.component.scss'
})
export class DebitDateVariationComponent {
  @Input() form: FormGroup;
  @Input() currentDebitDate: string;


  public keys: IFormKey[] = CommonUtils.assign(debit_date_form_keys)
  ngOnChanges(): void {
    
    FormUtils.disableFormFields(this.form, ['currentDebitDate']);
    FormUtils.enableFormFields(this.form, ['newDebitDate']);
    FormUtils.patchFormFromObject(
      {
        variationDate: moment().format('YYYY-MM-DD'),
        newDebitDate: null,
        currentDebitDate: this.currentDebitDate
      },
      this.form
    );
  }
}
